export const hasPagePermission = (permissions, needed) => {
  // admin has "*"
  if (permissions?.includes("*")) return true;

  return permissions?.includes(needed);
};
